import { render, staticRenderFns } from "./briefTrainingReportCO.vue?vue&type=template&id=89fa7ba2&scoped=true"
import script from "./briefTrainingReportCO.vue?vue&type=script&lang=js"
export * from "./briefTrainingReportCO.vue?vue&type=script&lang=js"
import style0 from "./briefTrainingReportCO.vue?vue&type=style&index=0&id=89fa7ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fa7ba2",
  null
  
)

export default component.exports